const blockFields = `
  id
  typeHandle
  idName
  theme
  bodyAlignInline
  bodyAlignBlock
  backgroundImageFade {
    url @transform(mode: "crop", width: 2000, immediately: true)
    title
  }
  backgroundImageFadeMobile {
    url @transform(mode: "crop", width: 640, immediately: true)
    title
  }
  backgroundImage {
    url @transform(mode: "crop", width: 2000, immediately: true)
    title
  }
  backgroundImageMobile {
    url @transform(mode: "crop", width: 640, immediately: true)
    title
  }
  backgroundVideo {
    url
    title
    embeddedAsset {
      title
      url
      providerName
    }
  }
  heading
  copy
  button {
    type
    url
    text
    target
  }
`

export const CBackgroundImageCopyFragments = {
  field: `
    fragment backgroundImageCopy on backgroundImageCopy_MatrixField {
      ... on backgroundImageCopy_block_Entry {
        ${blockFields}
      }
    }
  `,
  field2: `
    fragment backgroundImageCopy2 on backgroundImageCopy2_MatrixField {
      ... on backgroundImageCopy2_block_Entry {
        ${blockFields}
      }
    }
  `,
  field3: `
    fragment backgroundImageCopy3 on backgroundImageCopy3_MatrixField {
      ... on backgroundImageCopy3_block_Entry {
        ${blockFields}
      }
    }
  `,
  uiField: `
    fragment uiBackgroundImageCopy on uiBackgroundImageCopy_MatrixField {
      ... on uiBackgroundImageCopy_block_Entry {
        ${blockFields}
      }
    }
  `,
}
